<div class="tab-inner-content">
  <h2>General Ledger Report</h2>
  <h5>
    From {{ startDate | date : "MM/d/YYYY" }} to
    {{ endDate | date : "MM/d/YYYY" }}
  </h5>
  <table>
    <tr>
      <th>Date</th>
      <th>Partner</th>
      <th>Debit (in AED)</th>
      <th>Credit (in AED)</th>
    </tr>
    <ng-container *ngFor="let group of generalLedgerReport">
      <tr class="title">
        <td>{{ group.accountName }} - {{ group.accountType }}</td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <ng-container *ngFor="let item of group.transactions">
        <tr class="child">
          <td>{{ item.date | date : "MM/d/YYYY"}}</td>
          <td>{{ item.reference }}</td>
          <td>{{ item.debit | number : "1.2-2" }}</td>
          <td>{{ item.credit | number : "1.2-2" }}</td>
        </tr>
      </ng-container>
    </ng-container>
    <ng-container>
      <tr *ngIf="generalLedgerReport?.length === 0">
        <td colspan="4" class="no-data">
          No data available
        </td>
      </tr>
    </ng-container>
  </table>
</div>
